<template>
  <div class="is-flex is-align-items-center">
    <button-outline
      label="Refresh input data"
      color="is-success"
      data-id="refresh-input-data-selection"
      :loading="isLoading"
      :disabled="isLoading"
      @click="refreshInputData"
    />
    <span class="tag" style="font-size: 0.6rem">{{ items.length }}</span>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
import request from '@/requests'
import type { MasterItem, TasksScreenManager } from '@/logic/TasksScreen'
import { STATUS_OK } from '@/constants'
import { actions } from '@/store'
import notifications from '@/util/Notifications'

@Component({
  name: 'RefreshInputData',
})
export default class RefreshInputData extends Vue {
  @Prop({}) manager!: TasksScreenManager
  @Prop({}) items!: Array<MasterItem>
  @Prop({}) type!: 'installation' | 'inspection'
  @Prop({}) updateActions!: Function

  protected isLoading = false

  protected async refreshInputData() {
    this.isLoading = true

    const requests = this.items.map((item) =>
      request.tasks.submitTicketInputRefresh(item.address, this.type, item.projectId)
    )

    const refreshResponses = await Promise.all(requests)

    const itemsSucceeded: Array<MasterItem> = []
    const itemsFailed: Array<MasterItem> = []

    refreshResponses.forEach((response, idx) => {
      const item = this.items[idx]
      const list = response.status === STATUS_OK ? itemsSucceeded : itemsFailed
      list.push(item)
    })

    await Promise.all(itemsSucceeded.map((item) => this.manager.updateTaskDataForItem(item)))

    if (this.manager.selectedMasterItem) {
      const { address, detailTaskType } = this.manager.selectedMasterItem
      const matchingItem = itemsSucceeded.find((item) => item.address === address)
      if (matchingItem && detailTaskType === this.type) {
        this.manager.setSelectedMasterItem(matchingItem, this.type, true)
      }
    }

    this.isLoading = false

    actions.common.commitNotifications([])
    notifications.addNotification({
      message:
        itemsSucceeded.length > 0
          ? `${itemsSucceeded.length} items have been refreshed`
          : 'No items to refresh',
      type: 'success',
    })

    if (itemsFailed.length > 0) {
      notifications.addNotification({
        message: `${itemsFailed.length} items produced an error`,
        type: 'danger',
      })
    }

    this.updateActions()
  }
}
</script>
